import type { JsonValue } from '@lotushealth/lotushealth_js_sdk/schemas';

import type { RxChangeActionApprove } from '../api/dosespotActionApi';

interface BuildRxChangeApproveRequestOptions {
  toolInput: Record<string, JsonValue>;
  comment: string;
  priorAuthNumber: string;
}

export function buildRxChangeApproveRequest({
  toolInput,
  comment,
  priorAuthNumber,
}: BuildRxChangeApproveRequestOptions): RxChangeActionApprove {
  const selectedMedicationId = toolInput.selectedMedicationId;

  return {
    action: 'approve',
    selected_medication_id: typeof selectedMedicationId === 'number' ? selectedMedicationId : null,
    comment: comment || null,
    prior_auth_number: priorAuthNumber || null,
  };
}
